import {SidebarTranslationOrdersListItem} from "./SidebarTranslationOrdersListItem";
import {Card} from "@contentful/f36-components";

export const SidebarTranslationOrdersList = ({ orders }) => {
    return (
        <Card className="max-h-310 overflow-y-scroll">
            {orders.map((order, index) => <SidebarTranslationOrdersListItem key={order.id} order={order} isLast={index+1 === orders.length} />)}
        </Card>
    );
}